import { Injectable } from '@angular/core';
import { PutObjectCommand, S3Client } from '@aws-sdk/client-s3';
import { environment } from 'src/environments/environment';
interface Parameters {
  Bucket: string;
  Key: string;
  Body?: any;
  ContentType?: string;
}
interface FileLocationParams {
  bucketName: string;
  directory: string;
  fileName: string;
  fileExtension: string;
}
interface UploadFileResponse {
  message: string;
}
@Injectable({
  providedIn: 'root',
})
export class UploadService {
  private readonly iamAccessKey = environment.aws.accessKeyId;

  private readonly iamSecretAccessKey = environment.aws.secretAccessKey;

  private readonly bucketRegion = environment.aws.region;

  private readonly client = new S3Client({
    region: this.bucketRegion,
    credentials: {
      accessKeyId: this.iamAccessKey,
      secretAccessKey: this.iamSecretAccessKey,
    },
  });

  uploadFile = async (file: File, fileLocationParams: FileLocationParams): Promise<UploadFileResponse> => {
    const fileLocation = `${environment.aws.cdnUri}/${environment.stage}/${fileLocationParams.directory}/${fileLocationParams.fileName}.${fileLocationParams.fileExtension}`;
    const key = `${environment.stage}/${fileLocationParams.directory}/${fileLocationParams.fileName}.${fileLocationParams.fileExtension}`;
    const uploadParams: Parameters = {
      Bucket: fileLocationParams.bucketName,
      Key: key,
      Body: file,
      ContentType: file.type,
    };
    const command = new PutObjectCommand(uploadParams);
    try {
      await this.client.send(command);
      return { message: fileLocation };
    } catch (err) {
      return { message: err as unknown as string };
    }
  };
}
